export default __webpack_public_path__ + "static/media/docInverted.32d598e6.svg";